const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x0db5ca5Fd5E07E4038273CF5710E06fFcD0fecC0',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x009cD9fdbBc4C3A8DbBb1B6a22bA7Da32d7FDF90'
}

export default priceContracts